module.exports = __webpack_public_path__ + "img/img48.47c10bc0.png";